export default __webpack_public_path__ + "static/media/MuseoSans_700-webfont.b9db3918.woff";